import course1 from '../img/courses/course13.jpg'
import course2 from '../img/courses/course14.jpg'
import course3 from '../img/courses/course15.jpg'
import course4 from '../img/courses/course16.jpg'
import course5 from '../img/courses/course17.jpg'
import course6 from '../img/courses/course18.jpg'

const FundamentalWebDesignData = [
    {
        img: course1,
        p1Tag: 'Any Stream',
        coursesHeading: 'Html',
        core: 'Web Designing Module',
        courseDis: 'HTML is the most basic building block of the Web. It defines the meaning and...',
        bgColor: '#3498db'
    },
    {
        img: course2,
        p1Tag: 'Any Commerce Stream',
        coursesHeading: 'Html5',
        core: 'Web Designing Module',
        courseDis: 'It is a new version of the language HTML, with new elements, attributes, and...',
        bgColor: '#2874a6'
    },
    {
        img: course3,
        p1Tag: 'Any Stream',
        coursesHeading: 'CSS3',
        core: 'Web Designing Module',
        courseDis: 'CSS3 is the latest evolution of the Cascading Style Sheets language in simple and easy...',
        bgColor: '#f20f10'
    },
    {
        img: course4,
        p1Tag: 'Any Stream',
        coursesHeading:'JavaScript',
        core: 'Web Designing Module',
        courseDis: 'JavaScript often abbreviated as JS, is a programming language that conforms to the...',
        bgColor: '#fd29c5'
    },
    {
        img: course5,
        p1Tag: 'Any Stream',
        coursesHeading: 'jQuery',
        core: 'Web Designing Module',
        courseDis: 'jQuery is a JavaScript library designed to simplify HTML DOM tree traversal and...',
        bgColor: '#27ae60'
    },
    {
        img: course6,
        p1Tag: 'Any Stream',
        coursesHeading: 'Bootstrap',
        core: 'Web Designing Module',
        courseDis: 'Bootstrap is a free and open-source CSS framework directed at responsive, mobile-first...',
        bgColor: '#5d6d7e'
    },
]

export default FundamentalWebDesignData